import r from"lodash.isfunction";var t=(t,n)=>{r(t)?t(n.current):t.current=n.current};export{t as m};
